import React from 'react'
import { useParams } from "react-router-dom";

const Service = () => {

  const { serviceName } = useParams();

  // Example: fetch from dynamicData
  // const service = dynamicData[0].subpages[serviceId];

  return (
    <div>Service is {serviceName}</div>
  )
}

export default Service